<hr />
<div class="row my-2">
  <div class="col-sm-4">
    <h6>
      <img
        class="p-2"
        ngSrc="assets/images/icons/tractos.svg"
        alt="Tractos"
        height="50"
        width="50"
      />{{ entityName }}
    </h6>
  </div>
  <div class="col-sm-8 text-end">
    <div class="input-search-container-new">
      <span class="material-symbols-outlined search-icon"> search </span>
      <input
        placeholder="Buscar"
        class="input-search-datatable"
        id="custom-search-input"
        type="text"
        [(ngModel)]="searchText"
        (input)="applyFilter()"
      />

      <button
        id="tractos-list-new"
        class="btn-btn-create"
        (click)="onNewTracto()"
        *ngIf="showButton('create')"
      >
        Crear {{ entityName }}
      </button>
      <button
        id="tractos-list-refresh"
        class="btn mx-2 btn-refresh"
        (click)="onRefresh()"
      >
        <span class="material-symbols-outlined"> refresh </span>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="text-center my-5" *ngIf="isGettingTractos">
      <app-spinner message="Cargando {{ entityName }}"></app-spinner>
    </div>
    <div class="col-xs-12">
      <div class="table-responsive-sm" *ngIf="!isGettingTractos">
        <table
          datatable
          [dtOptions]="dtOptions"
          class="table display nowrap"
          style="width: 100%"
        >
          <caption>
            Lista de Vehículos
          </caption>
          <thead>
            <tr class="text-center">
              <th
                scope="col"
                *ngFor="let attribute of tractosAttributes"
                [hidden]="hideColumn(attribute)"
              >
                {{ attribute }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tracto of tractos">
              <td>
                <a
                  id="tractos-list-{{ tracto.licensePlate }}"
                  (click)="onSelectedTracto(tracto)"
                  style="color: #0d6efd"
                  >{{ tracto.sapId! | sapId }}</a
                >
              </td>
              <td>
                <span>
                  <img
                    [ngSrc]="getImageSrc(tracto.status)"
                    height="25"
                    width="25"
                    alt="Estado"
                  />
                </span>
                {{ tracto.status | master : "VEHICLES#STATUSES" }}
              </td>
              <td>{{ tracto.licensePlate }}</td>
              <td [hidden]="hideColumn('Transportista')">
                {{ tracto.carrier!.name }}
              </td>
              <td>{{ tracto.center | master : "CENTERS" }}</td>
              <td>
                <span
                  class="badge border rounded-4 text-bg-light mx-1"
                  *ngIf="hasToExpireDocuments(tracto)"
                >
                  <span class="badge border rounded-circle text-bg-light">{{
                    tracto.documentsToExpire
                  }}</span>
                  por vencer</span
                >
                <span
                  class="badge border rounded-4 text-bg-light mx-1"
                  *ngIf="hasExpiredDocuments(tracto)"
                >
                  <span class="badge border rounded-circle text-bg-light">{{
                    tracto.documentsExpired
                  }}</span>
                  vencido</span
                >
              </td>
              <td>
                <span
                  class="badge border rounded-4 text-bg-light mx-1"
                  *ngFor="let blockingMotive of tracto.blockingMotives"
                >
                  {{ blockingMotive }}</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
